const initialState = {
    itemData: [],
    towItemFormData: {},
    hasTowItems: false
};

const towItemsReducer = (state = initialState, action) => {
    if (action.type === 'TOW_ITEMS_DATA') {
		return Object.assign({}, state, {
            itemData: action.itemData,
            hasTowItems: true
		});
    }

    if (action.type === 'LOAD_TOW_ITEMS') {
        return Object.assign({}, state, {
            towItemFormData: action.towItemFormData
        });
    }

    if (action.type === 'TOW_ITEMS_SELECTED') {
        return Object.assign({}, state, {
            selectedTowItems: action.selectedTowItems
        });
    }
    return state;
};

export default towItemsReducer;


// WEBPACK FOOTER //
// ./src/reducers/towItemsReducer.js